export default "__VITE_ASSET__Bq5_e5QV__"